/**
 * Nearest scrollable ancestor of `node`, or null when the element scrolls
 * with the document.
 *
 * Exists because `IntersectionObserver`'s `rootMargin` expands only the
 * *root's* rect: an intermediate overflow container still clips the target
 * with its own unexpanded box. So an observer left on the implicit viewport
 * root gets zero prefetch lead for anything inside an inner scroller — the
 * target's intersection rect is empty until it is genuinely visible. Passing
 * the real scroll container as `root` is what makes a rootMargin mean
 * anything on those surfaces.
 *
 * Returning null is correct (and is what the caller should pass through) for
 * document-scrolled pages, where the viewport already is the scroll container.
 */
export function getScrollParent(node: Element | null): HTMLElement | null {
  let element = node?.parentElement ?? null
  while (element) {
    const overflowY = getComputedStyle(element).overflowY
    if (overflowY === 'auto' || overflowY === 'scroll') return element
    element = element.parentElement
  }
  return null
}
